let MenuItems = [
    {
        label: "Giriş",
        to: "/dashboard",
        icon: "mdi mdi-home-outline",
    },
    {
        label: "Lisanslar",
        to: "/",
        // count: 2,
        icon: "mdi mdi-layers",
        childs: [
            {
                label: "Aktif Lisanslar",
                to: "/licenses/active",
                // count: 1937,
                // letter: "Ac"
            },
            {
                label: "Deneme Lisansları",
                to: "/licenses/trial",
                // count: 1937,
                // letter: "Tr"
            },
            {
                label: "Süresi Dolan Lisanslar",
                to: "/licenses/expired",
                // count: 234,
                // letter: "Ex"
            },
            {
                label: "Geliştirici Lisansları",
                to: "/licenses/dev",
                // count: 565,
                // letter: "Dev"
            },
            {
                label: "Ücretsiz Lisanslar",
                to: "/licenses/free",
                // count: 123,
                // letter: "Fr"
            },
            {
                label: "Tüm Lisanslar",
                to: "/licenses/all",
                // count: 123,
                // letter: "All"
            }
        ]
    },

    {
        label: "Ürünler",
        to: "/",
        // count: 2,
        icon: "mdi mdi-package-variant-closed",
        childs: [
            {
                label: "Ürün Listesi",
                to: "/products/list",
                // count: 2,
                // letter: "Pro"
            },
            {
                label: "Kategoriler",
                to: "/products/categories",
                // count: 2,
                // letter: "Cat"
            }
        ]
    },
    {
        label: "Raporlar",
        to: "/",
        icon: "mdi mdi-chart-bar",
        childs: [
            {
                label: "Satış Raporları",
                to: "/stats/sales",
                // count: 2,
                // letter: "A"
            },
            {
                label: "Ürün Raporları",
                to: "/stats/products",
                // count: 2,
                // letter: "Cat"
            }
        ]
    },
    {
        label: "Ayarlar",
        to: "/",
        // count: 2,
        icon: "mdi mdi-settings-outline",
        childs: [
            {
                label: "Kullanıcı Yönetimi",
                to: "/users/list",
                // count: 2,
                // letter: "Usr"
            }
        ]
    }
];

export const backendBaseUrl = "https://lcs.gri.net";
// CRM API: lp.grilabs.net CRM'den tek tıkla girişte (/sso) bileti buraya sorar
export const crmApiBaseUrl = "https://crm-api.grilabs.net";
// export const backendBaseUrl = "https://localhost:5001";
export default MenuItems;

export function debounce (fn, time) {
    let timeoutId
    return wrapper
    function wrapper (...args) {
        if (timeoutId) {
            clearTimeout(timeoutId)
        }
        timeoutId = setTimeout(() => {
            timeoutId = null
            fn(...args)
        }, time)
    }
}

export const licenseTypes = [
    {value:"trial", label: "Deneme Sürümü"},
    {value:"full", label: "Tam Sürüm"},
    {value:"limited", label: "Sınırlı Süreli Lisans"},
    {value:"dev", label: "Geliştirici Lisansı"},
    {value:"free", label: "Ücretsiz Lisans"},
    {value:"other", label: "Diğer"}
]
// ionCube Encoder sürümü (EncoderVersion): boş = 15 (current)
export const encoderVersionOptions = [
    {value: "14", label: "14 (Legacy)"},
    {value: "13", label: "13 (Obsolete)"}
]
export const encoderVersionDefault = "15"

// ioncube config JSON string ya da nesne olabilir; anahtar büyük/küçük harf farkını da tolere eder
export const parseIonCubeConfig = (cfg) => {
    if (typeof cfg === "string") {
        try {
            cfg = JSON.parse(cfg)
        } catch (e) {
            return null
        }
    }
    return (typeof cfg === "object" && cfg !== null) ? cfg : null
}
export const getIonCubeEncoderVersion = (cfg) => {
    cfg = parseIonCubeConfig(cfg)
    if (cfg === null) return ""
    const v = cfg.encoderVersion || cfg.EncoderVersion
    return typeof v === "string" ? v : ""
}
// Kaldırılan eski encoder alanını config'ten çıkarır; kayıtta gönderilmemeli
export const stripLegacyIonCubeKeys = (cfg) => {
    const parsed = parseIonCubeConfig(cfg)
    if (parsed === null) return cfg
    const legacy = ["encoder" + "Base", "Encoder" + "Base"].filter(k => k in parsed)
    if (legacy.length === 0) return cfg
    const out = {...parsed}
    legacy.forEach(k => delete out[k])
    return out
}
// tüm alanlar boşsa true (kayıtta null gönderilir)
export const isIonCubeConfigEmpty = (cfg) => {
    cfg = parseIonCubeConfig(cfg)
    if (cfg === null) return true
    const val = (a, b) => cfg[a] !== undefined ? cfg[a] : cfg[b]
    const list = v => (Array.isArray(v) ? v : []).filter(i => String(i).trim() !== "")
    return (val("slug", "Slug") || "") === ""
        && (val("commit_sha", "commit_sha") || "") === ""
        && getIonCubeEncoderVersion(cfg) === ""
        && list(val("encoderVersions", "EncoderVersions")).length === 0
        && list(val("ignore", "Ignore")).length === 0
        && list(val("copy", "Copy")).length === 0
}
export const encoderVersions = [
    {value:"4", label: "4"},
    {value:"5", label: "5"},
    {value:"5.3", label: "5.3"},
    {value:"5.4", label: "5.4"},
    {value:"5.5", label: "5.5"},
    {value:"5.6", label: "5.6"},
    {value:"56", label: "5.6"},
    {value:"71", label: "7.1"},
    {value:"72", label: "7.2"},
    {value:"74", label: "7.4"},
    {value:"81", label: "8.1"},
    {value:"82", label: "8.2"},
    {value:"83", label: "8.3"},
    {value:"84", label: "8.4"},
]

// Encoder sürümüne göre desteklenen PHP hedefleri (ionCube Encoder "PHP language range" listesinden)
const encoderTargetsObsolete = ["4", "5", "5.3", "5.4", "5.5", "5.6", "56", "71", "72", "74", "81", "82"]
const encoderTargetsLegacy = [...encoderTargetsObsolete, "83"]
const encoderTargetsCurrent = [...encoderTargetsLegacy, "84"]
export const encoderVersionTargets = {
    "13": encoderTargetsObsolete,
    "14": encoderTargetsLegacy,
    "15": encoderTargetsCurrent
}
export const supportedEncoderVersions = (encoderVersion) => {
    const targets = encoderVersionTargets[encoderVersion]
    return targets ? encoderVersions.filter(v => targets.indexOf(v.value) > -1) : encoderVersions
}

export const phpVersions = [
    {value:"5.6", label: "5.6"},
    {value:"7.0", label: "7.0"},
    {value:"7.1", label: "7.1"},
    {value:"7.2", label: "7.2"},
    {value:"7.3", label: "7.3"},
    {value:"7.4", label: "7.4"},
    {value:"8.0", label: "8.0"},
    {value:"8.1", label: "8.1"},
    {value:"8.2", label: "8.2"},
    {value:"8.3", label: "8.3"},
    {value:"8.4", label: "8.4"}
]

export const datetime_format = "YYYY-MM-DDTHH:mm:ss[Z]"

export const customSelectStyles = {
    container: (provided, state) => ({
        ...provided,
        flex: '1 1 auto',
        color: '#333'
    }),
    control: (provided, state) => ({
        ...provided,
        borderRadius: '0 0 0 0'
    })
}
export const ionCubeConfigDefault = {
    slug: "",
    encoderVersion: "",
    encoderVersions: [],
    ignore: [""],
    copy: [""],
    commit_sha: ""
}

export const ionCubeConfigDefaultAlt = {
    slug: "",
    encoderVersion: "",
    encoderVersions: [""],
    ignore: [""],
    copy: [""],
    commit_sha: ""
}
